import moment from "moment";

export const validateIsEmail = (value) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(value);
}

export const validateReplaceNumber = (value) => {
    // return the new number accepting only numbers positive and negative
    return value.replace(/\D/g, '');
}  

export const validateIsRequired = (value) => {
    return value.trim() !== '';
}

export const validateIsTel = (value) => {
    const re = /^\d{10}$/;
    return re.test(value);
}

export const validateIsDate = (value) => {
    return moment(value, "DD/MM/YYYY", true).isValid();
  };
  
  export const validateIsAdult = (value) => {
    const birthday = moment(value, "DD/MM/YYYY", true);
    if (!birthday.isValid()) return false;
    return moment().diff(birthday, "years") >= 18;
  };
  


// WEBPACK FOOTER //
// ./src/helpers/validateInput.js